import PropTypes from "prop-types";
import styled from "styled-components";

const StyledDistrictCell = styled.div`
  min-width: 114px;
  padding-right: 4px;
  width: 284px;

  @media screen and (min-width: 540px) {
    width: 324px;
  }
`;

const DistrictCell = ({ children }) => (
  <StyledDistrictCell>{children}</StyledDistrictCell>
);

DistrictCell.propTypes = {
  children: PropTypes.node,
};

export default DistrictCell;
